<span class="fs-small" [innerHTML]="notification ? getNotificationMessage(notification) : ''"> </span>
